import { AfterViewInit, Component, ElementRef, Input, ViewChild  } from '@angular/core';
import { ApplicationContextService, RolePermissionService } from 'lib-core-shared';
import { ControlBaseDirective } from '../../directives/control-base.directive';


@Component({
  selector: 'lib-number-box',
  templateUrl: './number-box.component.html',
  styleUrls: ['./number-box.component.scss']
})
export class NumberBoxComponent extends ControlBaseDirective implements AfterViewInit {
  constructor(public roleService: RolePermissionService, public applicationContext: ApplicationContextService) {
    super(roleService, applicationContext);
  }
  @Input() public defaultWidth: boolean = true;
  @ViewChild('numberinput') public numberInput: ElementRef | undefined;
  @Input() public min : number = 0;
  @Input() public max : number = 100000000000;
  @Input() appendWith?: string;

  public ngAfterViewInit(): void {
    if (this.numberInput?.nativeElement) {
      this.numberInput.nativeElement.min = this.min;
      this.numberInput.nativeElement.max = this.max;
    }
   // super.ngAfterContentInit();
  }

  public prevent(evt: any) {
    if(this.disabled) {
      evt.preventDefault();
    }
  }
}

